module.exports = __webpack_public_path__ + "static/media/bulk-upload.68fcf146.png";